// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__jykaj","navItem":"Sidebar_navItem__qjLIu","active":"Sidebar_active__VjHH-","navIcon":"Sidebar_navIcon__TwUqG","navBadge":"Sidebar_navBadge__tjD1z"};